














































import { Component, Prop, Vue } from "vue-property-decorator";
import { FactorGroup, FactorResource } from "@/api/model/FactorResource";
import { Choice } from "@/api/model/Choice";
import ChoiceFactorInput from "@/components/choice-input/ChoiceFactorInput.vue";
import _ from "lodash";

@Component({
    components: {FactorValueInput: ChoiceFactorInput}
})
export default class QuestionnaireFixedTableInput extends Vue {

    @Prop()
    tableFactorGroup!: FactorGroup;

    @Prop()
    choice!: Choice

    @Prop()
    modelFactorResources!: { [id: string]: FactorResource };

    get orderedRows(): FactorGroup[] {
        return this.tableFactorGroup.childrenIds
            .map(f => this.factors[f] as FactorGroup)
            .filter(f => f && f.groupTypeDefinition.type === 'TABLE_ROW')
    }

    get orderedColumns(): FactorGroup[] {
        return this.tableFactorGroup.childrenIds
            .map(f => this.factors[f] as FactorGroup)
            .filter(f => f && f.groupTypeDefinition.type === 'TABLE_COLUMN')
    }

    get factors() {
        return this.modelFactorResources;
    }


    get headers() {
        let headers: any[] = [
            {text: 'Display Order', value: 'displayOrder', sortable: true, align: ' d-none'},
            {text: this.tableFactorGroup.groupTypeDefinition.rowsName, value: 'rowName', sortable: false, width: 160}];

        if (this.orderedColumns.length > 0) {
            this.orderedColumns
                .filter(col => col && col.numWeightingDots || 0 > 0)
                .forEach(col => {
                    headers.push({
                        text: this.factors[col.id].name,
                        value: col.id,
                        sortable: false,
                        width: this.getWidth(col.type)
                    })
                });
        }

        return headers;
    }

    get tableGrid() {
        let grid: any = {};
        this.orderedColumns.forEach(c => {
            grid[c.id] = {};
            this.orderedRows.forEach(r => {
                let factorIds = _.intersection(c.childrenIds, r.childrenIds)
                if (factorIds.length === 1) {
                    grid[c.id][r.id] = factorIds[0]
                }
            })
        })
        return grid;
    }


    get tableData() {
        return this.orderedRows
            .filter(row => row.numWeightingDots !== 0)
            .map((row, index) => {
                let rowDefinition: any = {
                    displayOrder: index,
                    rowName: this.factors[row.id].name,
                    rowId: row.id
                };
                let rowColumnData: any = {};
                for (let colIndex in this.orderedColumns) {
                    let col = this.orderedColumns[colIndex];
                    if (col.numWeightingDots !== 0) {

                        let cellFactor = this.tableGrid[col.id][row.id]
                        rowColumnData[col.id] = {
                            factorId: cellFactor,
                            value: this.choice[cellFactor.dataField]
                        }
                    }
                }
                return Object.assign(rowDefinition, rowColumnData);
            })
    }

    private getWidth(type: string) {
        switch (type) {
            case 'TEXT':
                return 200;
            case 'FILE':
            case 'CATEGORICAL':
                return 160;
        }
        return 140;
    }

}
